// What the order popups and the Cenik page show. The amount that is really charged is the Stripe price
// behind each product on the server; keep these in step with it.
export const PRICES = {
  keeper_1y: 20,
  keeper_5y: 30,
  candle_1y: 20,
  candle_5y: 30,
  highlight: 20,
  thank_you: 10,
  memory: 10,
  // "Spominska za davno pokojne": a memory page without an obituary, paid at once for 2 or 10 years.
  past_2y: 20,
  past_10y: 30,
};

export const euro = (amount) => `${amount} €`;

// "Izberi Skrbnika" in the keeper popup. The free 10 days need the death document and a manual check.
export const KEEPER_OPTIONS = [
  { value: "", label: "Izberi Skrbnika" },
  { value: "free", label: "10 dni – brezplačno" },
  { value: "keeper_1y", label: `1 leto – ${euro(PRICES.keeper_1y)}` },
  { value: "keeper_5y", label: `5 let – ${euro(PRICES.keeper_5y)}` },
];

export const CANDLE_OPTIONS = [
  { value: "", label: "Izberi svečko" },
  { value: "candle_1y", label: `1 leto – ${euro(PRICES.candle_1y)}` },
  { value: "candle_5y", label: `5 let – ${euro(PRICES.candle_5y)}` },
];

// The heading of Step 0 follows the product the visitor came for.
export const STEP_ZERO_TITLES = {
  keeper: "Postani skrbnik",
  candle: "Spominska svečka",
  thank_you: "Dodaj zahvalo",
  memory: "Dodaj spomin",
};

// "Spominska stran: Ime Priimek, Kraj"
export const memoryPageLabel = (obituary) =>
  [`${obituary.name ?? ""} ${obituary.sirName ?? ""}`.trim(), obituary.city || obituary.location]
    .filter(Boolean)
    .join(", ");

// "Tule" in the candle popups opens this example memory page; "tukaj" explains the double benefit.
export const EXAMPLE_MEMORY_URL = "https://www.osmrtnica.com/m/Mario_Danilo_Primo_311225";
export const DOUBLE_BENEFIT_TEXT =
  "Dvojna korist: Spominska svečka je hkrati tudi darilo: poleg svečke in vpisa, podarite obstoječemu skrbniku spominske strani hkrati tudi podaljšanje njegovega statusa skrbnika za enako obdobje.";

// Keeper popup messages.
export const KEEPER_REQUEST_SENT =
  "Hvala! Vašo prijavo bomo pregledali in vam status Skrbnika omogočili v najkrajšem času, običajno v naslednji uri ali dveh.";

// "Spominska za davno pokojne" (people who died years ago). The double period is a promotion until this day;
// the same text is used in the popup and on /posodobitve.
export const PAST_PROMO_END = "15.11.";
export const PAST_PROMO_END_TEXT = "15. novembra";
export const PAST_OPTIONS = [
  { value: "past_2y", label: `Spominska stran za 2 leti - ${PRICES.past_2y}€` },
  { value: "past_10y", label: `Spominska stran za 10 let - ${PRICES.past_10y}€` },
];
export const PAST_MEMORIAL_REQUEST_SENT =
  "Hvala! Dokument bomo pregledali in vam po e-pošti sporočili, ko bo spominska stran pripravljena.";
